import deApi from './de/api.json'
import deCommon from './de/common.json'
import deControllers from './de/controllers.json'
import deDevise from './de/devise.json'
import deErrors from './de/errors.json'
import deGraphql from './de/graphql.json'
import deModels from './de/models.json'
import deServices from './de/services.json'
import deUi from './de/ui.json'
import enGbApi from './en-GB/api.json'
import enGbDevise from './en-GB/devise.json'
import enGbServices from './en-GB/services.json'
import enGbUi from './en-GB/ui.json'
import enApi from './en/api.json'
import enCommon from './en/common.json'
import enControllers from './en/controllers.json'
import enDevise from './en/devise.json'
import enErrors from './en/errors.json'
import enGraphql from './en/graphql.json'
import enModels from './en/models.json'
import enServices from './en/services.json'
import enUi from './en/ui.json'
import esEsApi from './es-ES/api.json'
import esEsCommon from './es-ES/common.json'
import esEsControllers from './es-ES/controllers.json'
import esEsDevise from './es-ES/devise.json'
import esEsErrors from './es-ES/errors.json'
import esEsModels from './es-ES/models.json'
import esEsServices from './es-ES/services.json'
import esEsUi from './es-ES/ui.json'
import esApi from './es/api.json'
import esCommon from './es/common.json'
import esControllers from './es/controllers.json'
import esDevise from './es/devise.json'
import esErrors from './es/errors.json'
import esGraphql from './es/graphql.json'
import esModels from './es/models.json'
import esServices from './es/services.json'
import esUi from './es/ui.json'
import frCaApi from './fr-CA/api.json'
import frCaCommon from './fr-CA/common.json'
import frCaDevise from './fr-CA/devise.json'
import frCaErrors from './fr-CA/errors.json'
import frCaGraphql from './fr-CA/graphql.json'
import frCaModels from './fr-CA/models.json'
import frCaNumber from './fr-CA/number.json'
import frCaUi from './fr-CA/ui.json'
import frApi from './fr/api.json'
import frCommon from './fr/common.json'
import frControllers from './fr/controllers.json'
import frDevise from './fr/devise.json'
import frErrors from './fr/errors.json'
import frGraphql from './fr/graphql.json'
import frModels from './fr/models.json'
import frServices from './fr/services.json'
import frUi from './fr/ui.json'
import itApi from './it/api.json'
import itCommon from './it/common.json'
import itControllers from './it/controllers.json'
import itDevise from './it/devise.json'
import itErrors from './it/errors.json'
import itGraphql from './it/graphql.json'
import itModels from './it/models.json'
import itServices from './it/services.json'
import itUi from './it/ui.json'
import ptBrApi from './pt-BR/api.json'
import ptBrCommon from './pt-BR/common.json'
import ptBrDevise from './pt-BR/devise.json'
import ptBrErrors from './pt-BR/errors.json'
import ptBrGraphql from './pt-BR/graphql.json'
import ptBrModels from './pt-BR/models.json'
import ptBrServices from './pt-BR/services.json'
import ptBrUi from './pt-BR/ui.json'
import ptApi from './pt/api.json'
import ptCommon from './pt/common.json'
import ptControllers from './pt/controllers.json'
import ptDevise from './pt/devise.json'
import ptErrors from './pt/errors.json'
import ptGraphql from './pt/graphql.json'
import ptModels from './pt/models.json'
import ptServices from './pt/services.json'
import ptUi from './pt/ui.json'


export const de = {
  ...deApi['de'],
  ...deCommon['de'],
  ...deControllers['de'],
  ...deDevise['de'],
  ...deErrors['de'],
  ...deGraphql['de'],
  ...deModels['de'],
  ...deServices['de'],
  ...deUi['de']
};
export const enGb = {
  ...enGbApi['en-GB'],
  ...enGbDevise['en-GB'],
  ...enGbServices['en-GB'],
  ...enGbUi['en-GB']
};
export const en = {
  ...enApi['en'],
  ...enCommon['en'],
  ...enControllers['en'],
  ...enDevise['en'],
  ...enErrors['en'],
  ...enGraphql['en'],
  ...enModels['en'],
  ...enServices['en'],
  ...enUi['en']
};
export const esEs = {
  ...esEsApi['es-ES'],
  ...esEsCommon['es-ES'],
  ...esEsControllers['es-ES'],
  ...esEsDevise['es-ES'],
  ...esEsErrors['es-ES'],
  ...esEsModels['es-ES'],
  ...esEsServices['es-ES'],
  ...esEsUi['es-ES']
};
export const es = {
  ...esApi['es'],
  ...esCommon['es'],
  ...esControllers['es'],
  ...esDevise['es'],
  ...esErrors['es'],
  ...esGraphql['es'],
  ...esModels['es'],
  ...esServices['es'],
  ...esUi['es']
};
export const frCa = {
  ...frCaApi['fr-CA'],
  ...frCaCommon['fr-CA'],
  ...frCaDevise['fr-CA'],
  ...frCaErrors['fr-CA'],
  ...frCaGraphql['fr-CA'],
  ...frCaModels['fr-CA'],
  ...frCaNumber['fr-CA'],
  ...frCaUi['fr-CA']
};
export const fr = {
  ...frApi['fr'],
  ...frCommon['fr'],
  ...frControllers['fr'],
  ...frDevise['fr'],
  ...frErrors['fr'],
  ...frGraphql['fr'],
  ...frModels['fr'],
  ...frServices['fr'],
  ...frUi['fr']
};
export const it = {
  ...itApi['it'],
  ...itCommon['it'],
  ...itControllers['it'],
  ...itDevise['it'],
  ...itErrors['it'],
  ...itGraphql['it'],
  ...itModels['it'],
  ...itServices['it'],
  ...itUi['it']
};
export const ptBr = {
  ...ptBrApi['pt-BR'],
  ...ptBrCommon['pt-BR'],
  ...ptBrDevise['pt-BR'],
  ...ptBrErrors['pt-BR'],
  ...ptBrGraphql['pt-BR'],
  ...ptBrModels['pt-BR'],
  ...ptBrServices['pt-BR'],
  ...ptBrUi['pt-BR']
};
export const pt = {
  ...ptApi['pt'],
  ...ptCommon['pt'],
  ...ptControllers['pt'],
  ...ptDevise['pt'],
  ...ptErrors['pt'],
  ...ptGraphql['pt'],
  ...ptModels['pt'],
  ...ptServices['pt'],
  ...ptUi['pt']
};


export const resources = {
  'de': { translation: { ...de } },
  'en-GB': { translation: { ...enGb } },
  'en': { translation: { ...en } },
  'es-ES': { translation: { ...esEs } },
  'es': { translation: { ...es } },
  'fr-CA': { translation: { ...frCa } },
  'fr': { translation: { ...fr } },
  'it': { translation: { ...it } },
  'pt-BR': { translation: { ...ptBr } },
  'pt': { translation: { ...pt } },
};